import React from "react";
import { Listbox } from "@headlessui/react";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export const languageOptions = [
  { label: "فارسی", value: "fa" },
  { label: "انگلیسی", value: "en" },
];

export const LanguageSelect = ({onChange}) => {
  const [selected, setSelected] = useState(languageOptions[0]);

  return (
    <Listbox
      value={selected}
      onChange={(selected) => {
        onChange(selected);
        setSelected(selected);
      }}
      defaultValue={languageOptions[0]}
    >
      <div className="language-select-wrapper">
        <Listbox.Button className="language-select-btn">
          {({ open }) => (
            <>
              <span className="language-select-label">{selected.label}</span>
              <span>
                {open ? (
                  <FiChevronUp size={12} color="#00BA9F" />
                ) : (
                  <FiChevronDown size={12} color="#00BA9F" />
                )}
              </span>
            </>
          )}
        </Listbox.Button>
        <Listbox.Options className="language-select-options">
          <div className="language-select-option-wrapper">
            {languageOptions.map((languageOption) => (
              <Listbox.Option
                className="language-select-option"
                key={languageOption.label}
                value={languageOption}
              >
                {({ selected }) => (
                  <>
                    <button
                      className={`language-select-option-btn${
                        selected ? " active" : ""
                      }`}
                    >
                      <span>{languageOption.label}</span>
                    </button>
                  </>
                )}
              </Listbox.Option>
            ))}
          </div>
        </Listbox.Options>
      </div>
    </Listbox>
  );
};
